import { FC } from "react";
import FormContainer from "./form";

const CreateCategoryContainer: FC = () => {
    return (
        <section>
            <div className="bg-white p-3 rounded-md mb-6 shadow-md">
                <FormContainer />
            </div>
        </section>
    );
};

export default CreateCategoryContainer;
